import type React from "react"

// Define a recursive type for structured data
type StructuredDataValue = string | number | boolean | null | StructuredDataObject | StructuredDataValue[]

interface StructuredDataObject {
  [key: string]: StructuredDataValue
}

interface StructuredDataProps {
  data: StructuredDataObject
}

const StructuredData: React.FC<StructuredDataProps> = ({ data }) => {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />
}

export default StructuredData

